import React from 'react'
import MainNavigation from '../components/MainNavigation'

function Home() {
    return (
        <div>
            <MainNavigation/>
        </div>
    )
}

export default Home
